import React, { useContext, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Avatar, Badge, Layout, Dropdown, Drawer, Divider } from 'antd';
import {
  PoweroffOutlined,
} from '@ant-design/icons';
import AuthContext from '../../contexts/authProvider';
import SettingContext from '../../contexts/settingProvider';
import logo_s from '../../images/logo_s.svg';
import { menu } from '../../utils/functionTool';

const { Header } = Layout;

const AppHeader = () => {
  const { user, UnAuthUser } = useContext(AuthContext);
  const { dark } = useContext(SettingContext);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  
  const showDrawer = () => {
    setOpen(true)
  }

  const onClose = () => {
    setOpen(false)
  }

  const userItems = useMemo(
    () => [
      {
        key: 'logout',
        label: <span onClick={() => UnAuthUser()}>登出</span>,
        icon: (
          <span onClick={() => UnAuthUser()}>
            <PoweroffOutlined />
          </span>
        ),
        name: '登出',
        path: '',
      },
    ],
    [UnAuthUser]
  );

  const userName = user?.name || '未知使用者'
  const userFirstName = user?.name?.[0] || 'U'

  return (
    <Header className='app-header'>
      <div className="app-header-container">
        <div className="app-header-left">
          <div className="app-header-logo">
            <Link to="/">
                <img src={logo_s} alt="微電能源-能源策略評估平台" />
            </Link>
          </div>
        </div>

        <ul className="app-header-right">
          <li>
            <div className="user">
              <Dropdown placement="bottom" menu={{ items: userItems }} trigger={['click']}>
                <div style={{display:'flex'}}>
                  <Badge size="small" count={0}>
                    <Avatar size="small" style={{
                      backgroundColor: '#fde3cf',
                      color: '#f56a00',
                    }}>
                      {userFirstName}
                    </Avatar>
                  </Badge>
                  <span className="name">{userName}</span>
                </div>
              </Dropdown>
            </div>
          </li>
        </ul>
        <div
            className="app-header-mobile-menu"
            onClick={() => {
                showDrawer()
            }}
        >
            <em />
            <em />
        </div>
      </div>
      <Drawer
        title=""
        placement="right"
        onClose={onClose}
        open={open}
        width={300}
        className={dark ? 'dark' : ''}
      >
        {menu.map((item) => (
            <p key={item.key}>
                <span
                    onClick={() => {
                        navigate(item.path)
                        onClose()
                    }}
                    style={{ cursor: 'pointer', display: 'block' }}
                >
                    {item.name}
                </span>
            </p>
        ))}
        <Divider />
        {userItems.map((item) => (
            <p key={item.key * 2}>
                <span
                    onClick={() => {
                        if (item.name === '登出') {
                            UnAuthUser()
                        } else {
                            navigate(item.path)
                        }
                        onClose()
                    }}
                >
                    {item.name}
                </span>
            </p>
        ))}
      </Drawer>
    </Header>
  );
};

export default AppHeader;
